import React from "react";

const CreditCard02 = ({ width, height, color, bgColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill={bgColor || "none"}
    >
      <path
        d="M18.3334 8.33332H1.66669M9.16669 11.6667H5.00002M1.66669 6.83332L1.66669 13.1667C1.66669 14.1001 1.66669 14.5668 1.84834 14.9233C2.00813 15.2369 2.2631 15.4919 2.5767 15.6517C2.93322 15.8333 3.39993 15.8333 4.33335 15.8333L15.6667 15.8333C16.6001 15.8333 17.0668 15.8333 17.4233 15.6517C17.7369 15.4919 17.9919 15.2369 18.1517 14.9233C18.3334 14.5668 18.3334 14.1001 18.3334 13.1667V6.83332C18.3334 5.8999 18.3334 5.43319 18.1517 5.07667C17.9919 4.76307 17.7369 4.5081 17.4233 4.34831C17.0668 4.16666 16.6001 4.16666 15.6667 4.16666L4.33335 4.16666C3.39993 4.16666 2.93322 4.16666 2.5767 4.34831C2.2631 4.5081 2.00813 4.76307 1.84834 5.07667C1.66669 5.43319 1.66669 5.8999 1.66669 6.83332Z"
        stroke={color || "#374040"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CreditCard02;

